import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListGameFreespin = (params) => {
    return axios.get(`${backendHost}/api/admin/fs-game/list`, {params});
};

export {
    getListGameFreespin
}